import styles from '../../styles/manager/UserList.module.scss'

interface UserListProps {
  Name: React.ReactNode
  Level: string
  School: string
  Phone: string
  Email: string
  Center: string
  Modify: React.ReactNode
  Delete: React.ReactNode
}

const UserListItem = ({
  Name,
  Level,
  School,
  Phone,
  Email,
  Center,
  Modify,
  Delete,
}: UserListProps) => {
  const cellData = [Name, Level, School, Phone, Email, Center, Modify, Delete]

  return (
    <div className={styles.listItem}>
      {cellData.map((data, index) => (
        <div
          key={index}
          className={`${styles.cell} ${index >= 6 ? styles.modifyIcon : ''}`}
        >
          {typeof data === 'string' ? <span>{data}</span> : data}
        </div>
      ))}
    </div>
  )
}

export default UserListItem
